import React, { useState, useEffect } from 'react';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });

  const [status, setStatus] = useState({
    submitted: false,
    success: false,
    message: '',
  });

  const [loading, setLoading] = useState(false);
  const [emailJSLoaded, setEmailJSLoaded] = useState(false);

  useEffect(() => {
    if (window.emailjs) {
      setEmailJSLoaded(true);
      return;
    }

    const script = document.createElement('script');
    script.src =
      'https://cdn.jsdelivr.net/npm/@emailjs/browser@3/dist/email.min.js';
    script.async = true;
    script.onload = () => {
      window.emailjs.init('SUA_CHAVE_PUBLICA_EMAILJS');
      setEmailJSLoaded(true);
    };
    script.onerror = () => {
      setStatus({
        submitted: true,
        success: false,
        message:
          'Erro ao carregar a biblioteca de envio de e-mail. Tente novamente mais tarde.',
      });
    };

    document.body.appendChild(script);

    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    if (!window.emailjs) {
      setStatus({
        submitted: true,
        success: false,
        message:
          'Erro ao enviar e-mail: biblioteca não disponível. Tente recarregar a página.',
      });
      setLoading(false);
      return;
    }

    const templateParams = {
      name: formData.name,
      message: formData.message,
      email: formData.email,
    };

    window.emailjs
      .send('service_9nuag1v', 'template_giju1lx', templateParams)
      .then(() => {
        setStatus({
          submitted: true,
          success: true,
          message:
            'Sua mensagem foi enviada com sucesso! Entraremos em contato em breve.',
        });
        setFormData({ name: '', email: '', message: '' });
      })
      .catch(() => {
        setStatus({
          submitted: true,
          success: false,
          message:
            'Ocorreu um erro ao enviar sua mensagem. Por favor, tente novamente.',
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <section id="contato" className="contact-section">
      <div className="contact-inner">
        <div className="contact-header">
          <p className="section-label">Contato</p>
          <h2 className="section-title">Vamos conversar?</h2>
          <p
            className="section-subtitle"
            style={{ margin: '0.75rem auto 0', textAlign: 'center' }}
          >
            {"Estamos aqui para entender seu desafio e propor a solução ideal"}
          </p>
        </div>

        {status.submitted && (
          <div
            className={`contact-alert ${status.success ? 'success' : 'error'}`}
            role="alert"
            style={{ marginBottom: '1.5rem' }}
          >
            {status.message}
          </div>
        )}

        <form onSubmit={handleSubmit} className="contact-form">
          <div className="contact-row">
            <input
              type="text"
              placeholder="Nome"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
            <input
              type="email"
              placeholder="Email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
          <textarea
            placeholder="Sua mensagem..."
            name="message"
            value={formData.message}
            onChange={handleChange}
            required
            rows="6"
          />
          <button
            type="submit"
            className="contact-submit"
            disabled={loading || !emailJSLoaded}
          >
            {loading
              ? 'Enviando...'
              : emailJSLoaded
              ? 'Enviar Mensagem'
              : 'Carregando...'}
          </button>
        </form>
      </div>
    </section>
  );
};

export default Contact;
